import React, { forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from "antd/es/typography/Title";
import Text from "antd/es/typography/Text";
import Row from "antd/es/row/index";
import Col from "antd/es/col/index";

export default forwardRef((props: any, ref: any) => {
  const { inputData, language } = props,
    { questions } = inputData;

  return (
    <Row type="flex" justify="center" align="middle">
      <Col span={21}>
        <Text style={{ textAlign: "center" }}>
          <span dangerouslySetInnerHTML={{
            __html: questions[language] || "no question for selected language"
          }}/>
        </Text>
      </Col>
    </Row>
  );
});
